<template>
  <ul>
    <li
      v-for="(filter, index) in displayedFilters"
      :key="index"
    >
      <div class="top">
        <svg>
          <use :xlink:href="`#icon-${filter.icon}`"></use>
        </svg>
        <span class="label">{{ filter.label }}</span>
      </div>
      <div
        class="hover"
        :class="{'-parenthesis': filter.hover}"
      >
        {{ filter.hover || '&nbsp;' }}
      </div>
      <div class="bottom">
        <template v-if="filter.maxValue">
          <button
            :disabled="filter.value <= 0"
            @click="DECREASE_FILTER_VALUE(filter.id)"
          >
            -
          </button>
          {{ filter.value || '--' }}
          <button
            :disabled="filter.value >= filter.maxValue"
            @click="INCREASE_FILTER_VALUE(filter.id)"
          >
            +
          </button>
        </template>
        <template v-else>
          <button @click="toggleActive(filter.id)">
            <svg
              v-show="filter.value"
              class="check"
            >
              <use xlink:href="#icon-check-2"></use>
            </svg>
          </button>
        </template>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    filters: {
      type: Array,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    INCREASE_FILTER_VALUE(id) {
      this.$store.commit('vehicles/filters/INCREASE_FILTER_VALUE', { id })
    },
    DECREASE_FILTER_VALUE(id) {
      this.$store.commit('vehicles/filters/DECREASE_FILTER_VALUE', { id })
    },
    toggleActive(id) {
      this.$store.commit('vehicles/filters/TOGGLE_BOOLEAN_VALUE', { id })
    },
  },
  computed: {
    isCommercialVehiculeSelected() {
      return this.$store.getters['vehicles/filters/isCommercialVehiculeSelected']
    },
    displayedFilters() {
      return this.isCommercialVehiculeSelected
        ? this.filters.filter((filter) => filter.isCommercialEnabled)
        : this.filters
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";
@import "../../../../../_src/sass/config/responsive";

ul {
  display: -webkit-box;
  flex-direction: column;
  overflow: hidden;

  @include teq-breakpoint($medium) {
    flex-direction: row;
    padding: 20px 0;
  }
}

li {
  display: flex;
  padding: 20px;

  @include teq-breakpoint($medium) {
    flex-direction: column;
    padding: 0;
  }

  & + & {
    @include teq-breakpoint($medium) {
      margin: 0 0 0 50px;
    }
  }
}

.top,
.bottom {
  align-items: center;
  display: flex;
}

.top {
  flex: 1;

  @include teq-breakpoint($medium) {
    flex: 0;
  }
}

.bottom {
  font-family: $f-graphie-bold;
  justify-content: space-between;
  line-height: 1;
  max-width: 70px;
  width: 100%;

  @include font-size(14px);
}

.label {
  color: $black;
  margin: 0 0 0 5px;
}

.hover {
  color: $black;
  display: block;
  height: 17px;
  line-height: 1;
  margin: 4px;
  opacity: 1;
  transition: opacity 300ms ease-out;

  @include teq-breakpoint($medium) {
    margin: 4px 0;
    opacity: 0;
  }

  li:hover & {
    opacity: 1;
  }

  &.-parenthesis {
    &::before {
      content: '(';
    }

    &::after {
      content: ')';
    }

    @include teq-breakpoint($medium) {
      &::before {
        content: ' ';
      }

      &::after {
        content: ' ';
      }
    }
  }
}

svg {
  max-height: 18px;
  max-width: 16px;
}

.check {
  max-height: 12px;
  max-width: 12px;
}

button {
  align-items: center;
  background: none;
  border: solid 2px black;
  cursor: pointer;
  display: flex;
  height: 20px;
  justify-content: center;
  outline: none;
  padding: 0;
  width: 20px;
}

</style>
